/* eslint-disable import/prefer-default-export */

export function toPascalCase(str) {
  return str.replace(/\w+/g, (w) => {
    return w[0].toUpperCase() + w.slice(1).toLowerCase();
  });
}
